<div class="modal-footer">
    @if (modalCloseBtnName) {
        <button mat-flat-button color="primary" type="button" class="dark-blue-border-btn me-3" (click)="onClose()">
            {{ modalCloseBtnName }}
        </button>
    }
    @if (nextOperationBtnName) {
        <button mat-flat-button type="button" color="primary" (click)="onSave()" [disabled]="isFormInvalid">
            {{ isPrimaryButtonClicked ? '' : nextOperationBtnName }}
            @if (isPrimaryButtonClicked) {
                <app-loader [count]="3"></app-loader>
            }
        </button>
    }
</div>
